import {Dialog, ServerSideAutocomplete} from 'finsys-webcomponent'
// import {Stack, Grid} from '@mui/material/Grid'
import {Stack, Grid} from '@mui/material'
import {fetchUsers, fetchUsersHQ} from 'api/TS/query/_CommonQueries'

type ReassignProps = {
  step: string | null,
  value: string | null,
  onChange: () => void,
  onClose: () => void,
  onSubmit: () => void,
  isDisabled: boolean,
  isLoading: boolean,
}

/**
 * To open Reassign Dialog
 * @param value
 * @param onChange
 * @param onClose
 * @param onSubmit
 * @param userList
 * @param step
 * @param isDisabled
 * @param isLoading
 * @return {JSX.Element}
 * @constructor
 */
export const Reassign = ({
  step,
  value,
  onChange,
  onClose,
  onSubmit,
  isDisabled,
  isLoading,
}: ReassignProps) => {
  return (
    <Grid container>
      <Grid item xs={12} md={6}>
        <Dialog
          fullWidth
          maxWidth={'md'}
          type={'info'}
          title={'Reassign Requestor'}
          content={
            <Stack spacing={3}>
              <ServerSideAutocomplete
                textFieldProps={{
                  required: true,
                  placeholder: 'Search for user',
                  //     step === 3 || step === 5
                  //       ? 'Search for HQ user'
                  //       : step === 0
                  //       ? 'Search for user'
                  //       : '',
                }}
                label={'Select user to reassign to'}
                value={value?.user}
                handleOnChange={(value) => {
                  onChange((prevState) => {
                    return {
                      ...prevState,
                      value: {...prevState.value, user: value},
                    }
                  })
                }}
                fetchOptions={(value) => {
                  // if (step === 0) {
                  return fetchUsers(value)
                  // } else if (step === 3 || step === 5) {
                  //   console.log('step: ', value)
                  //   return fetchUsersHQ(value)
                  // }
                }}
                getOptionLabel={(option) => {
                  return option?.email ?? option
                  //   return option.fullname ? `${option.fullname} (${option.email})` : ''
                }}
                isOptionEqualToValue={(option, value) => {
                  return option?.email === value?.email
                }}
              />
            </Stack>
          }
          buttons={[
            {label: 'Cancel', type: 'text', onClick: onClose, disabled: isDisabled},
            {
              label: 'Reassign',
              type: 'danger',
              onClick: onSubmit,
              disabled: isDisabled,
              loading: isLoading,
            },
          ]}
          handleOnClose={onClose}
        />
      </Grid>
    </Grid>
  )
}
